// 全局「专业版功能」提示弹窗（TB-ProFeature）统一入口
// 规范：src/components/common/1.html「2. 专业版提示 (Alert)」
// 用法：this.$tbProFeature()   —— 组件 / mixin 内（推荐）
//       tbProFeature()         —— 无 this 上下文时（工具函数、拦截器等）
// 效果：380px 圆角弹窗 + 警示图标 + 提示文案 + 客服二维码 + 单个「知道了」按钮
// 二维码：取站点配置 wechatCustomerQrCode（各页「联系客服」弹窗通用那张）；
//         未配置则只展示文案，不展示占位空图。
import { MessageBox } from "element-ui";
import i18n from "@/i18n";
import { getConfigValue, waitForSiteConfig } from "@/utils/site";

const QR_CONFIG_KEY = "wechatCustomerQrCode";

// 站点配置长时间未就绪时的兜底等待，避免点击后一直不弹窗（此时退化为纯文案提示）
const SITE_CONFIG_TIMEOUT = 3000;

// 同一时刻只允许一个专业版提示弹窗，防止连点 / 多处触发叠层
let proDialogVisible = false;

// i18n 未命中时会原样返回 key，这里统一兜底成中文字面量
function translate(key, fallback) {
  const text = i18n.t(key);
  return !text || text === key ? fallback : text;
}

function resolveServiceQr() {
  return getConfigValue(QR_CONFIG_KEY) || "";
}

function buildContentHtml(description, qrAlt) {
  const qrSrc = resolveServiceQr();
  const qrHtml = qrSrc
    ? `<img class="tb-pro-feature__qr" src="${qrSrc}" alt="${qrAlt}" />`
    : "";

  return `<div class="tb-pro-feature"><div class="tb-pro-feature__desc">${description}</div>${qrHtml}</div>`;
}

function waitSiteConfigWithTimeout() {
  return Promise.race([
    waitForSiteConfig(),
    new Promise((resolve) => setTimeout(resolve, SITE_CONFIG_TIMEOUT)),
  ]);
}

export function tbProFeature(opts = {}) {
  if (proDialogVisible) return Promise.resolve();

  // 二维码来自站点配置，等配置就绪再弹，避免首次进入时图片为空
  return waitSiteConfigWithTimeout().then(() => {
    // 等待期间可能已被另一处调用弹出，二次确认
    if (proDialogVisible) return;

    const title = opts.title || translate("common.proFeature.title", "系统提示");
    const description =
      opts.description ||
      translate(
        "common.proFeature.description",
        "当前功能仅专业版用户可用，请扫码咨询客服"
      );
    const confirmButtonText =
      opts.confirmButtonText ||
      translate("common.proFeature.confirm", "知道了");
    const qrAlt = translate("common.proFeature.qrAlt", "客服二维码");

    proDialogVisible = true;

    return MessageBox.alert(
      buildContentHtml(description, qrAlt),
      title,
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText,
        type: "warning",
        customClass: "tb-custom-dialog is-pro-feature",
      }
    )
      .catch(() => {})
      .finally(() => {
        proDialogVisible = false;
      });
  });
}

export default {
  install(Vue) {
    Vue.prototype.$tbProFeature = function (opts) {
      return tbProFeature(opts);
    };
  },
};
